






































import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

@Component({
    components: {

    }
}) export default class FeaturesCard extends Mixins(VueHoduCommon) {

    beforeCreate() : void {
        document.title = '카드 | 주요기능';
    }

    mounted() : void {
        
    }

}

